<template>
    <div :style="style" ref="lavContainer"  style="width: 100%; height: 100&;"></div>
</template>

<script>
import lottie from 'lottie-web';

export default {
    props: {
        options: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            style: {
                overflow: 'hidden',
                margin: '0 auto'
            }
        }
    },

    mounted() {
        this.anim = lottie.loadAnimation({
            container: this.$refs.lavContainer,
            renderer: 'svg',
            loop: true,      // 是否循環播放
            autoplay: true,  // 是否自動播放
            animationData: this.options.animationData,
            rendererSettings: this.options.rendererSettings
        }
        );
        this.$emit('animCreated', this.anim)
    }
}
</script>